module.exports = __webpack_public_path__ + "img/banner_mobile.468b8814.png";